import { useContext, useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../context/AppContext";

import HeroReviews from "../../components/reviews/HeroReviews";
import WhatItCanDoReviews from "../../components/reviews/WhatItCanDoReviews";
import ResultsReviews from "../../components/reviews/ResultsReviews";
import ForWhomReviews from "../../components/reviews/ForWhomReviews";
import ReviewsForm from "../../components/reviews/ReviewsForm";
import ButtonBtn from "../../components/buttons/ButtonBtn";
import FAQBox from "../../components/FAQBox";
import ModalLoading from "../../components/ModalLoading";

import styles from "../../css/reviews/Reviews.module.css";
import sectionStyles from "../../css/reviews/Sections.module.css";

const FORM_ID = "reviews-form";

const ReviewsLP = () => {
  const { t } = useTranslation();
  const { isLogged, checkLoginStatus } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(true);

  const steps = t("reviews.procedure.steps", { returnObjects: true });
  const faqData = t("reviews.faq", { returnObjects: true });

  // Na mount ověř login status (důležité při příchodu z hubu)
  useEffect(() => {
    checkLoginStatus();
  }, []);

  // Označ původ pro navbar logo
  useEffect(() => {
    try {
      sessionStorage.setItem("last_lp", "reviews");
    } catch (e) {
      // ignore
    }
  }, []);

  // Jednotný loading stav (vzor převzat z HeatmapsLP) – min. 2 s + až je login resolved
  useEffect(() => {
    const startTime = Date.now();
    let minTimeTimer;

    const checkLoadingComplete = () => {
      const elapsed = Date.now() - startTime;
      const dataReady = isLogged !== null;

      if (dataReady && elapsed >= 2000) {
        setIsLoading(false);
      } else if (dataReady) {
        const remainingTime = 2000 - elapsed;
        minTimeTimer = setTimeout(() => setIsLoading(false), remainingTime);
      }
    };

    checkLoadingComplete();
    const interval = setInterval(checkLoadingComplete, 100);

    return () => {
      clearTimeout(minTimeTimer);
      clearInterval(interval);
    };
  }, [isLogged]);

  // CTA scrolluje na poptávkový formulář
  const scrollToForm = useCallback(() => {
    const el = document.getElementById(FORM_ID);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  if (isLoading || isLogged === null) {
    return <ModalLoading message="Načítání..." />;
  }

  return (
    <div className={`body ${styles.toolsBody}`}>
      <HeroReviews onCtaClick={scrollToForm} />

      <WhatItCanDoReviews onCtaClick={scrollToForm} />

      {/* <ResultsReviews onCtaClick={scrollToForm} /> */}

      <section
        className={`section section--q-htmp ${styles.section}`}
        data-component="how-to-set-up"
        id="how-to-set-up"
      >
        <article className="container">
          <h2 className={`title ${styles.heading}`}>
            {t("reviews.procedure.heading")}
          </h2>
          <div className="how" id="how" style={{ marginTop: "20px" }}>
            {Array.isArray(steps) &&
              steps.map((item, index) => (
                <div key={index} className="box is-connected center">
                  <h3 style={{ margin: 0 }}>
                    <span className={sectionStyles.stepNum}>{index + 1}.</span>
                    {item}
                  </h3>
                </div>
              ))}
          </div>
          <ButtonBtn
            onClick={(e) => {
              e.target.blur?.();
              scrollToForm();
            }}
            style={{ marginTop: "120px", marginInline: "auto" }}
            hoverBg={"white"}
            hoverColor={"black"}
          >
            {t("reviews.procedure.btn")}
          </ButtonBtn>
        </article>
      </section>

      <ForWhomReviews onCtaClick={scrollToForm} />

      <FAQBox faq={faqData} />

      <ReviewsForm id={FORM_ID} />
    </div>
  );
};

export default ReviewsLP;
